import {
  OrientationAxis,
  ViewportType,
} from "@cornerstonejs/core/enums";

export const MPRViewportsId = [
  "mprViewportAxial",
  "mprViewportSagittal",
  "mprViewportCoronal",
];

export const getMPRViewportInputs = (
  axialElement,
  sagittalElement,
  coronalElement
) => {
  return [
    {
      viewportId: MPRViewportsId[0],
      type: ViewportType.ORTHOGRAPHIC,
      element: axialElement,
      defaultOptions: {
        orientation: OrientationAxis.AXIAL,
      },
    },
    {
      viewportId: MPRViewportsId[1],
      type: ViewportType.ORTHOGRAPHIC,
      element: sagittalElement,
      defaultOptions: {
        orientation: OrientationAxis.SAGITTAL,
      },
    },
    {
      viewportId: MPRViewportsId[2],
      type: ViewportType.ORTHOGRAPHIC,
      element: coronalElement,
      defaultOptions: {
        orientation: OrientationAxis.CORONAL,
      },
    },
  ];
};
